export const environment = {
    production: false,
    envName: 'dev',
    baseApiUrl: 'https://dev-webapi.pogoenergy.com/',
    rewardsUrl: 'https://dev.pogoperks.com/',
    rewardsApiKey: 'dC8vP7fR0dK1yK2n',
    baseUrl: 'https://dev-my.pogoenergy.com/',
    host_en: 'www-dev.pogoenergy.com',
    host_es: 'es-dev.pogoenergy.com',
    amberAdminUrl: 'https://dev-admin.pogoenergy.com/',
    paymentusPrefix: 'secure4',
    webChatVariables: {
        isSignedIn: false,
        isChatSignedIn: false,
        user: {
            user_id: '',
            user_name: ''
        },
        locale: 'en-US'
    },
    azureSearchVariables: {
        adminKey: 'A83E5B9055E698BB8754C33DF48B2BC6',
        searchUrl: 'https://srch-alas-scus-dev.search.windows.net/indexes/ercot-index/docs?api-version=2020-06-30&$top=5'
    }
};



// WEBPACK FOOTER //
// ./src/environments/environment.ts